import { Outlet } from 'react-router-dom'

export default function LoggedArea() {
    return <Outlet />
}
